import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
import ListStyle from '@ckeditor/ckeditor5-list/src/liststyle';

export const editorConfig = {
    plugins: [
        EssentialsPlugin,
        BoldPlugin,
        ItalicPlugin,
        ParagraphPlugin,
        Alignment,
        ListStyle,
        LinkPlugin
    ],
    language: {
        ui: 'ar',
        content: 'ar'
    },
    toolbar: {
        items: [
            'bold',
            'italic',
            'alignment',
            'bulletedList',
            'numberedList',
            'undo',
            'redo',
            'link'
        ]
    }
}
